const buildCustomHelperTextStyles = (successMsg) => {
  if (successMsg) {
    const color = ({ palette: { primary } }) => primary.main
    return {
      sx: {
        color,
        '&.MuiFormHelperText-root.Mui-disabled': { color }
      }
    }
  }
  return {}
}

export { buildCustomHelperTextStyles }
